import { render, staticRenderFns } from "./seekAdd.vue?vue&type=template&id=1b749597&scoped=true"
import script from "./seekAdd.vue?vue&type=script&lang=js"
export * from "./seekAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b749597",
  null
  
)

export default component.exports